module.exports = __webpack_public_path__ + "img/PhoneSilver.1235bbd9.svg";